module.exports = __webpack_public_path__ + "img/Kraftfahrzeug.186802bf.svg";